module.exports = "/_next/static/images/Introduction-7e51ad079d46e96fb71e1b083fe90b47.webp";